import { withStyles } from '@material-ui/core'

import { InputBase } from './Input'

import { styles } from './styles'

export const Input = withStyles(styles)(InputBase)



// WEBPACK FOOTER //
// ./src/components/Input/index.js